import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  RejectRequirement,
  updateRequirement,
  modifydetails,
  getdistictName,
  school_name_block_wise,
  weo_approval,
  getAllBlocksFromDistrict,
  head_office_secretary_approval,
  dwo_approval,
  dm_approval,
  bulk_approval_show_api,
  bulk_approval_view_all_api,
  bulk_approval_accept_all_api,
  bulk_approval_api,
  bulk_approval_api_weo,
  approvalApiDwo,
  getAmenitiesType,
} from "../api/Users";
import { toast } from "react-toastify";
import {
  TextField,
  TablePagination,
  Modal,
  Button,
  Typography,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const Approve = ({ role, mainId, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [viewFilteredData, setViewFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [Block, setBlock] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [ViewAll, setViewAll] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [MainSelectedRow, setMainSelectedRow] = useState(true);
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rejectReasonError, setRejectReasonError] = useState(false); // Change initial state to false
  const [DistrictName, setDistrictName] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [District, setDistrict] = useState("");
  const [Allblocks, setAllBlocks] = useState([]);
  const [schoolId, setSchoolId] = useState("");
  const [allAmenityName, setAllAmenityName] = useState([]);
  const [postSchoolName, setPostSchoolname] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedFunds, setSelectFunds] = useState({});
  const [reqs, setReqs] = useState([]);
  const [requirementDistrictName, setRequirementDistrictName] = useState("");
  const [amenity, setAmenity] = useState("all");

  console.log(filteredData);

  const handleSelected = (event, index) => {
    const newSelectedRows = { ...selectedRows, [index]: event.target.checked };
    setSelectedRows(newSelectedRows);
  };
  const handleFundCheck = (event, index, id) => {
    const newSelectedFunds = {
      ...selectedFunds,
      [index]: event.target.checked,
    };
    setReqs((reqs) => [
      ...reqs,
      {
        requirement_id: id,
        is_available_fund: event.target.value == "on" ? 0 : 1,
      },
    ]);
    setSelectFunds(newSelectedFunds);
  };

  const handleSelectAll = (event) => {
    const newSelectedRows = {};
    if (event.target.checked) {
      viewFilteredData.forEach((row, index) => {
        newSelectedRows[index] = true; // Select all
      });
    }
    setSelectedRows(newSelectedRows);
  };

  const handleSchoolName = (e) => {
    try {
      setSchoolId(e.target.value);
      // getAllrequirements(District, Block, e.target.value);
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };

  const   handleAmenitiesName = (e) => {
    // let data = {
    //   role_id: role,
    //   district_code: userData.data.district_code,
    //   block_code: Block,
    //   amenities_id: e.target.val,
    // };
    // let abc = allAmenityName.filter((val) => val.name === e.target.value)[0];
    // setAmenity(abc ? abc.amenity_id : "all");
    setAmenity(e.target.value)
  };

  useEffect(() => {
    try {
      getAmenitiesType().then((res) => {
        setAllAmenityName(res.data.assets_name);
      });
    } catch (error) {
      console.error("Error in getting Amenities type:", error);
    }
  }, []);

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    setAllSchoolNames([]);

    const data = {
      block_code: e.target.value,
    };

    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
    // getAllrequirements(District, e.target.value, schoolId);
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    getDistictNames();
    console.log(userData);
  }, []);

  useEffect(() => {
    const data = {
      block_code: userData.data.block_code,
    };
    if (role == 5) {
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  }, []);

  const getAllrequirements = (district, block, school) => {
    setIsLoading(true);
    const data =
      role == 5
        ? {
            role_id: role,
            block_code: userData.data.block_code,
            school_id: school ? school : schoolId ? schoolId : "all",
          }
        : role == 6
        ? {
            role_id: role,
            district_code: userData.data.district_code,
            block_code: block ? block : Block ? Block : "all",
            // school_id: school ? school : schoolId ? schoolId : "all",
            amenities_id: amenity,
          }
        : role == 7
        ? {
            role_id: role,
            district_code: userData.data.district_code,
            block_code: block ? block : Block ? Block : "all",
            school_id: school ? school : schoolId ? schoolId : "all",
            // amenities_id:'all'
          }
        : {
            role_id: role,
            district_code: district ? district : District ? District : "all",
            // block_code: block ? block : Block ? Block : "all",
            // school_id: school ? school : schoolId ? schoolId : "all",
            // amenities_id:'all'
          };

    bulk_approval_show_api(data).then((res) => {
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        setFilteredData([]);
        toast.error(t("No Data Available!"));
      }
    });
    setIsLoading(false);
  };

  const ViewApproveAllRequirement = () => {
    setIsLoading(true);
    setSelectedRows({});
    const selectedData = viewFilteredData.filter(
      (_, index) => selectedRows[index]
    );

    if (selectedData.length === 0) {
      setIsLoading(false);
      toast.error(`Please select any rows first!`);
      return;
    }

    const requirementIds = Array.from(
      new Set(selectedData.map((item) => item.requirement_id))
    );

    const data = {
      role_id: role,
      user_id: userData.data.id,
      requirement_ids: requirementIds,
      school_id: selectedData[0].school_id,
    };

    let newReqs = [];

    selectedData.forEach(({ requirement_id }) => {
      if (!reqs.find((req) => req.requirement_id === requirement_id)) {
        newReqs.push({
          requirement_id,
          is_available_fund: 1,
        });
      }
    });

    reqs.map((reqs) => newReqs.push(reqs));

    const DWO_data = {
      role_id: role,
      user_id: userData.data.id,
      school_id: selectedData[0].school_id,
      requirements: newReqs,
    };

    if (role === 5 || role === 8 || role === 11) {
      bulk_approval_api_weo(data).then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          toast.success(t(res.message));
          window.location.reload();
        } else {
          setIsLoading(false);
          toast.error(t(res));
        }
      });
    } else if (role === 6) {
      approvalApiDwo(DWO_data).then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          toast.success(t(res.message));
          window.location.reload();
        } else {
          setIsLoading(false);
          toast.error(t(res));
        }
      });
    }
  };

  useEffect(() => {
    getAllrequirements("");
  }, [amenity]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleUpdateClick = (row) => {
    setSelectedRow({
      ...row,
    });
    setModalOpen(true);
  };

  const handleViewClick = (row) => {
    console.log(row);
    let data;
    if (role === 6) {
      data = {
        role_id: role,
        amenities_id: row.amenities_id,
        amenities_sub_type_id: row.amenities_sub_type_id,
      };
    } else if (role === 8 || role === 11) {
      data = {
        role_id: role,
        district_code: row.district_code,
      };
    } else {
      data = {
        role_id: role,
        school_id: row.school_id,
      };
    }

    bulk_approval_view_all_api(data).then((res) => {
      if (res.status === "success") {
        setViewFilteredData(res.data);
        setPostSchoolname(row.school_name);
        setRequirementDistrictName(res.data[0].district);
      } else {
        toast.error(t("No Data Available!"));
      }
    });

    setMainSelectedRow(true);
    setViewAll(true);
  };

  const handlerejectClick = (row) => {
    setSelectedRow(row);
    setModalOpen1(true);
  };

  const handleCloseModal = () => {
    setShowRejectReason(false);
    setModalOpen(false);
  };
  const handleCloseModal1 = () => {
    setShowRejectReason(false);
    setModalOpen1(false);
  };

  const handleCloseViewModal = () => {
    setViewAll(false);
  };

  const handleModify = (selectedRow) => {
    {
      const postData = {
        quantity: selectedRow.quantity,
        old_quantity: selectedRow.old_quantity,
        school_id: selectedRow.school_id,
        user_id: "",
        role_id: "",
        requirement_id: selectedRow.requirement_id,
      };

      modifydetails(postData)
        .then((response) => {
          setModalOpen(false);
          toast.success("Successfully Modified");
          window.location.reload();

          getAllrequirements("");
        })
        .catch((error) => {
          console.error("Error updating requirement:", error);
          toast.error(error.response.data.message);
        });
    }
  };

  const handleRejectWithReason = () => {
    setShowRejectReason(true);
    if (rejectReason.trim() === "") {
      setRejectReasonError(true);
      return;
    }

    const postData = {
      school_id: selectedRow.school_id,
      requirement_id: selectedRow.requirement_id,
      is_reject: true,
      remarks: rejectReason,
    };

    RejectRequirement(postData)
      .then((response) => {
        setModalOpen1(false);
        getAllrequirements("");
        toast.success(response.message || "Update successful");
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
    // getAllrequirements(selectedDistrictId, Block, schoolId);
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  useEffect(() => {
    if (role === 6 || role === 7) {
      const districtCode = userData.data.district_code;
      getAllBlocksFromDistrict(districtCode)
        .then((res) => {
          if (res.status === "success") {
            setAllBlocks(res.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
          setAllBlocks([]);
        });
    }
  }, [role, userData.data.district_code]);

  const HandleOnSearchClick = () => {
    let data = {
      role_id: role,
      district_code: userData.data.district_code,
      block_code: Block,
      amenities_id: amenity,
    };

    bulk_approval_show_api(data).then((res) => console.log(res));
  };

  console.log(userData);

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="my-4">{t("Approve Requirements")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                display: "flex",
                marginLeft: "3rem",
                width: "17rem",
                border: "",
                borderRadius: "35px",
                marginTop: "20px",
              }}
            />
          </div>
        </div>

        <div className="my-3 col-12 d-flex justify-content-between align-items-center">
          <div
            className="col-sm-3"
            style={{
              display:
                role == 4
                  ? "none"
                  : role == 5
                  ? "none"
                  : role == 6
                  ? "none"
                  : role == 7
                  ? "none"
                  : "block",
            }}
          >
            <label htmlFor="title" className="form-label">
              {t("District")}
            </label>
            <select
              name="asset_sub_type"
              onChange={handleDistrictChange}
              className="common-input form-select"
            >
              <option value="all">All</option>
              {DistrictName &&
                DistrictName.map((row, id) => (
                  <option
                    key={id}
                    value={row.district_code}
                    className="text-dark"
                  >
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div
            className="col-md-3"
            style={{
              display:
                role == 4
                  ? "none"
                  : role == 5
                  ? "none"
                  : role == 8
                  ? "none"
                  : role == 11
                  ? "none"
                  : "block",
            }}
          >
            <label className="form-label">{t("Block")} </label>
            <select
              name="GP" // value={AssetsType}
              className="common-input form-select"
              onChange={handleBlockChange}
              required
            >
              <option value="all">All</option>
              {/* Map assetOptions to generate option elements */}
              {Allblocks &&
                Allblocks.map((row, index) => (
                  <option key={index} value={row.code}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div
            className="col-md-3"
            style={{ display: role == 4 ? "none" : "block" }}
          >
            {role === 6 && (
              <>
                <label className="form-label">{t("Amenity Type")} </label>
                <select
                  name="SchoolName" // value={AssetsType}
                  className="common-input form-select"
                  onChange={handleAmenitiesName}
                  required
                >
                  <option value="all">All</option>
                  {allAmenityName &&
                    allAmenityName.map((row, index) => (
                      <option value={row.name}>{row.name}</option>
                    ))}
                </select>
              </>
            )}

            {role != 6 && role != 8 && role!= 11 &&(
              <>
                <label className="form-label">{t("School Name")} </label>
                <select
                  name="SchoolName" // value={AssetsType}
                  className="common-input form-select"
                  onChange={handleSchoolName}
                  required
                >
                  <option value="all">All</option>
                  {AllSchoolNames &&
                    AllSchoolNames.map((row, index) => (
                      <option value={row.school_id}>{row.school_name}</option>
                    ))}
                </select>
              </>
            )}
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "35px", height: "30px" }}
            onClick={getAllrequirements}
            // onClick={getData}
          >
            {t("Search")}
          </button>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              {role === 6 && (
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="center">{t("Amenity Type")}</TableCell>
                    <TableCell align="center">
                      {t("Amenity Sub-Type")}
                    </TableCell>
                    <TableCell align="center">{t("Block")}</TableCell>
                    <TableCell align="center">{t("Count")}</TableCell>
                    <TableCell align="center">{t("Action")}</TableCell>
                  </TableRow>
                </TableHead>
              )}

              {role != 6 && role != 8 && role != 11 &&(
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="center">{t("School Name")}</TableCell>
                    <TableCell align="center">{t("District")}</TableCell>
                    <TableCell align="center">{t("Block")}</TableCell>
                    <TableCell align="center">{t("Count")}</TableCell>
                    <TableCell align="center">{t("Action")}</TableCell>
                  </TableRow>
                </TableHead>
              )}

              {role === 8 && (
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="center">{t("District")}</TableCell>
                    <TableCell align="center">{t("Count")}</TableCell>
                    <TableCell align="center">{t("Action")}</TableCell>
                  </TableRow>
                </TableHead>
              )}
              {role === 11 && (
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="center">{t("District")}</TableCell>
                    <TableCell align="center">{t("Count")}</TableCell>
                    <TableCell align="center">{t("Limit Allocated By Dy. Secretary")}</TableCell>
                    <TableCell align="center">{t("Action")}</TableCell>
                  </TableRow>
                </TableHead>
              )}

              {!isLoading &&
                role === 6 &&
                filteredData &&
                filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {getSerialNumber(index)}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.amenities_type}
                          </TableCell>
                          <TableCell align="center">
                            {row.amenities_sub_type_name}
                          </TableCell>
                          <TableCell align="center">{row.block_name}</TableCell>
                          <TableCell align="center">
                            {row.total_quantity}
                          </TableCell>
                          <TableCell align="center">
                            <button
                              className="btn btn-primary mx-1"
                              onClick={() => handleViewClick(row)}
                            >
                              {t("View All")}
                            </button>
                            {/* <button
                            className="btn btn-success mx-1"
                            onClick={() => ApproveAllRequirement(row)}
                          >
                            Accept All
                          </button> */}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
              {!isLoading &&
                role != 6 &&
                role != 8 &&
                role !=11 &&
                filteredData &&
                filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) =>
                        row.total_quantity != 0 ? (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {getSerialNumber(index)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "15%" }}>
                              {row.school_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.district_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.block_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.total_quantity}
                            </TableCell>
                            <TableCell align="center">
                              <button
                                className="btn btn-primary mx-1"
                                onClick={() => handleViewClick(row)}
                              >
                                View All
                              </button>
                              {/* <button
                            className="btn btn-success mx-1"
                            onClick={() => ApproveAllRequirement(row)}
                          >
                            Accept All
                          </button> */}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              <h4>
                                {" "}
                                <i>{t("No Requirements")}</i>{" "}
                              </h4>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                  </TableBody>
                )}

              {!isLoading &&
                role == 8 &&
                filteredData &&
                filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) =>
                        row.total_quantity != 0 ? (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {getSerialNumber(index)}
                            </TableCell>
                            <TableCell align="center">
                              {row.district_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.total_quantity}
                            </TableCell>
                            <TableCell align="center">
                              <button
                                className="btn btn-primary mx-1"
                                onClick={() => handleViewClick(row)}
                              >
                                View All
                              </button>
                              {/* <button
                            className="btn btn-success mx-1"
                            onClick={() => ApproveAllRequirement(row)}
                          >
                            Accept All
                          </button> */}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              <h4>
                                {" "}
                                <i>{t("No Requirements")}</i>{" "}
                              </h4>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                  </TableBody>
                )}
              {!isLoading &&
                role == 11 &&
                filteredData &&
                filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) =>
                        row.total_quantity != 0 ? (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {getSerialNumber(index)}
                            </TableCell>
                            <TableCell align="center">
                              {row.district_name}
                            </TableCell>
                            <TableCell align="center">
                              {row.total_quantity}
                            </TableCell>
                            <TableCell align="center">
                              {row.total_limit}
                            </TableCell>
                            <TableCell align="center">
                              <button
                                className="btn btn-primary mx-1"
                                onClick={() => handleViewClick(row)}
                              >
                                View All
                              </button>
                              {/* <button
                            className="btn btn-success mx-1"
                            onClick={() => ApproveAllRequirement(row)}
                          >
                            Accept All
                          </button> */}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              <h4>
                                {" "}
                                <i>{t("No Requirements")}</i>{" "}
                              </h4>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                  </TableBody>
                )}
              
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {MainSelectedRow && (
        <Modal
          open={ViewAll}
          onClose={handleCloseViewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "32%",
              left: "52%",
              transform: "translate(-52%, -30%)",
              maxWidth: "95vw",
              maxHeight: "90vh",
              width: "100%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t(`All Requirement for ${requirementDistrictName}`)}
            </Typography>
            <div className="Table mb-6">
              <TableContainer
                component={Paper}
                style={{
                  boxShadow: "0px 13px 20px 0px #80808029",
                  overflow: "scroll",
                  maxHeight: "50vh",
                  overflowX: "hidden",
                }}
                className="my-4"
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          padding: "8px",
                          display:
                            role == 7 || role == 12 || role == 13
                              ? "none"
                              : "block",
                        }}
                        padding="checkbox"
                      >
                        <Checkbox
                          className="mt-3"
                          onChange={handleSelectAll}
                          checked={
                            viewFilteredData.length > 0 &&
                            viewFilteredData.every(
                              (row, index) => selectedRows[index]
                            )
                          }
                        />
                      </TableCell>
                      <TableCell>{t("Sr. No.")}</TableCell>
                      <TableCell align="center">{t("Requirement")}</TableCell>
                      <TableCell align="center">{t("School Name")}</TableCell>
                      <TableCell align="center">{t("GBC")}</TableCell>
                      <TableCell align="center">{t("Hostel Type")}</TableCell>
                      <TableCell align="center">{t("District")}</TableCell>
                      <TableCell align="center">{t("Block")}</TableCell>
                      <TableCell align="center">{t("Quantity")}</TableCell>
                      {/* <TableCell align="center">
                        {t("Tentative Amount")}
                      </TableCell> */}
                      <TableCell align="center">{t("Raised On")}</TableCell>
                      <TableCell align="center">
                        {t("Pending Date Count")}
                      </TableCell>
                      {role == 6 ? (
                        <TableCell align="center">
                          {t("Is Fund Available")}
                        </TableCell>
                      ) : (
                        ""
                      )}
                      <TableCell
                        align="center"
                        style={{
                          display:
                            role == 7 || role == 12 || role == 13
                              ? "none"
                              : "block",
                        }}
                      >
                        {t("Action")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ color: "white" }}>
                    {viewFilteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            style={{
                              display:
                                role == 7 || role == 12 || role == 13
                                  ? "none"
                                  : "block",
                            }}
                          >
                            <Checkbox
                              className="mt-3"
                              onChange={(e) => handleSelected(e, index)}
                              checked={selectedRows[index] ?? false} // Default to false if undefined
                            />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {getSerialNumber(index)}
                          </TableCell>
                          <TableCell align="center">
                            {row.requirement_name}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.school_name}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.gbc_type}
                          </TableCell>
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.hostel_type}
                          </TableCell>
                          <TableCell align="center">{row.district}</TableCell>
                          <TableCell align="center">{row.block}</TableCell>
                          <TableCell align="center">{row.quantity}</TableCell>
                          {/* <TableCell align="center">
                            {row.tentative_amount}
                          </TableCell> */}
                          <TableCell align="center" style={{ width: "15%" }}>
                            {row.creation_date}
                          </TableCell>
                          <TableCell align="center">
                            {row.pending_date_count}
                          </TableCell>
                          {role == 6 ? (
                            <TableCell align="center">
                              <Checkbox
                                className="mt-3"
                                onChange={(e) =>
                                  handleFundCheck(e, index, row.requirement_id)
                                }
                                checked={selectedFunds[index] ?? true} // Default to false if undefined
                              />
                            </TableCell>
                          ) : (
                            ""
                          )}
                          <TableCell
                            align="center"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography
                              variant="button"
                              className="primary-btn btn btn-sm"
                              style={{ margin: "8px" }}
                              hidden={role == 5 ? false : true}
                              id="btn1"
                              onClick={() => handleUpdateClick(row)}
                            >
                              {t("Modify")}
                            </Typography>
                            <Typography
                              variant="button"
                              style={{
                                margin: "8px",
                                display:
                                  role == 7 || role == 12 || role == 13
                                    ? "none"
                                    : "block",
                              }}
                              className="primary-btn btn btn-sm"
                              id="btn3"
                              onClick={() => {
                                handlerejectClick(row);
                              }}
                            >
                              {t("Reject")}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <button
                  variant="contained"
                  color="primary"
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "none",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                  }}
                  onClick={handleCloseViewModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={viewFilteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
            <div
              className=""
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                id="btn2"
                className="btn"
                style={{
                  marginRight: "10px",
                  display:
                    role == 7 || role == 12 || role == 13 ? "none" : "block",
                }}
                onClick={ViewApproveAllRequirement}
              >
                {t("Accept")}
              </button>
              <button
                className="btn btn-secondary"
                style={{
                  marginRight: "66px",
                  display:
                    role == 7 || role == 12 || role == 13 ? "none" : "block",
                }}
                onClick={handleCloseViewModal}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        </Modal>
      )}

      {selectedRow && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "32%",
              left: "52%",
              transform: "translate(-50%, -50%)",
              maxWidth: "90vw",
              width: "70%",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t("Update Requirement")}
            </Typography>
            <div className="row mb-3 d-flex justify-content-around">
              <div className="col-md-3">
                <label className="form-label">{t("Requirement")}</label>
                <input
                  type="text"
                  name="requirement"
                  defaultValue={selectedRow.requirement_name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">{t("Proposed  Quantity")}</label>
                <input
                  type="text"
                  name="old_quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      old_quantity: e.target.value,
                    }));
                  }}
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">{t("Modify Quantity")}</label>
                <input
                  type="text"
                  name="quantity"
                  defaultValue={selectedRow.quantity}
                  className="form-control"
                  onChange={(e) => {
                    setSelectedRow((prevRow) => ({
                      ...prevRow,
                      quantity: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
            </div>
            <div className="row mb-3"></div>
            {showRejectReason && (
              <div className="mb-3">
                <label className="form-label">
                  {t("Reason for Rejection")}
                </label>
                <input
                  type="text"
                  name="rejectreason"
                  value={rejectReason}
                  className={`form-control ${
                    rejectReasonError ? "border-danger" : ""
                  }`}
                  onChange={(e) => setRejectReason(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.target.value.length >= 5) {
                      setRejectReasonError(false);
                    }
                  }}
                  required
                />
                {rejectReasonError && (
                  <small className="text-danger">
                    {t("Reason for Rejection is required")}.
                  </small>
                )}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={() => handleModify(selectedRow)}
              >
                {t("Update")}
              </Button>
              <button
                variant="contained"
                color="primary"
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  background: "none",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
                onClick={handleCloseModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        open={modalOpen1}
        onClose={handleCloseModal1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "52%",
            transform: "translate(-50%, -50%)",
            maxWidth: "90vw",
            width: "70%",
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: 8,
            padding: 20,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {t("Reject Requirement")}
          </Typography>

          <div className="mb-3">
            <label className="form-label">{t("Reason for Rejection")}</label>
            <input
              type="textbox"
              name="rejectreason"
              value={rejectReason}
              className={`form-control ${
                rejectReasonError ? "border-danger" : ""
              }`}
              onChange={(e) => setRejectReason(e.target.value)}
              onKeyUp={(e) => {
                if (e.target.value.length >= 5) {
                  setRejectReasonError(false);
                }
              }}
              required
            />
            {rejectReasonError && (
              <small className="text-danger">
                {t("Reason for Rejection is required")}.
              </small>
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginRight: 8 }}
              onClick={() => handleRejectWithReason(selectedRow)}
            >
              {t("Reject")}
            </Button>
            <button
              variant="contained"
              color="primary"
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
              }}
              onClick={handleCloseModal1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Approve;
